import DocModelo from '@/models/DocModelo'
import { LocalStorageFacade } from 'paliari-js-utils'

export default {
  props: { docTipo: { type: String } },
  data() {
    return { resource: null }
  },
  methods: {
    navigate(routeName) {
      LocalStorageFacade.setItem('docModelo', this.resource)
      this.$router.push({
        name: routeName,
        params: this.$route.params,
      })
    },
  },
  created() {
    const { docTipo } = this
    const params = LocalStorageFacade.getItem('docModelo') || {}
    this.resource = new DocModelo({
      tipo: docTipo,
      ...params,
    })
  },
}
